module.exports = __webpack_public_path__ + "static/media/woman.038dbd32.svg";